module.exports = (View, processTemplateData = Odigeo._.identity) => View.extend({
    initialize(config = {}) {
        const mainTemplate = Odigeo._.get(config, 'resources.templates.main', Odigeo._.constant(''));
        const keys = Odigeo._.get(config, 'resources.keys', {});
        const {options} = config;
        this.$el.html(mainTemplate(processTemplateData({keys, options})));
        View.prototype.initialize.call(this, config);
    },
});
